import type { QueryClient } from '@tanstack/react-query';

/**
 * FIX-ATT — every query that shows attendance (clock, today's hours, monthly
 * calendar, daily detail, the day's logs, "תועד מתוך נוכחות") re-reads after a
 * clock-in / break / return / clock-out, from the top bar AND the attendance page.
 * `work-logs-monthly` (the page's "תועד X מתוך Y") and `attendance-vs-tickets`
 * were missing from the lists, so those figures stayed stale until a manual refresh.
 */
export const ATTENDANCE_REFRESH_KEYS: readonly (readonly string[])[] = [
  ['attendance-status'],
  ['attendance'],
  ['timer-status'],
  ['work-logs'],
  ['work-logs-monthly'],
  ['work-records'],
  ['attendance-vs-tickets'],
];

export function invalidateAttendanceViews(queryClient: Pick<QueryClient, 'invalidateQueries'>): void {
  for (const queryKey of ATTENDANCE_REFRESH_KEYS) {
    void queryClient.invalidateQueries({ queryKey: [...queryKey] });
  }
}
